"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accidentals_to_props = exports.accidentals_to_metadata = exports.accidentals_pretty = exports.accidentals_code = exports.accidentals = void 0;
exports.addDurationSuffix = addDurationSuffix;
exports.default = exports.annotation_position_to_character = void 0;
exports.describeAltoPitchPos = describeAltoPitchPos;
exports.describeBassPitchPos = describeBassPitchPos;
exports.describeNotation = describeNotation;
exports.describeNoteDuration = describeNoteDuration;
exports.describePitch = describePitch;
exports.describeTreblePitchPos = describeTreblePitchPos;
exports.durations = void 0;
exports.get_abs_pitch = get_abs_pitch;
exports.get_abs_pitch_number = get_abs_pitch_number;
exports.get_alto_pitch = get_alto_pitch;
exports.get_alto_pitch_number = get_alto_pitch_number;
exports.get_bass_pitch = get_bass_pitch;
exports.get_bass_pitch_number = get_bass_pitch_number;
exports.get_treble_pitch = get_treble_pitch;
exports.get_treble_pitch_number = get_treble_pitch_number;
exports.icons = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _react = _interopRequireDefault(require("react"));

var _abcjs = _interopRequireDefault(require("abcjs"));

require("./MusicEditor.css");

var _Button = _interopRequireDefault(require("react-bootstrap/Button"));

var _CompletedContext = require("../CompletedContext");

var _fractional = require("fractional");

var _dblflat = _interopRequireDefault(require("../assets/MusicEditor/dblflat.png"));

var _dblflat_disabled = _interopRequireDefault(require("../assets/MusicEditor/dblflat_disabled.png"));

var _dblsharp = _interopRequireDefault(require("../assets/MusicEditor/dblsharp.png"));

var _dblsharp_disabled = _interopRequireDefault(require("../assets/MusicEditor/dblsharp_disabled.png"));

var _flat = _interopRequireDefault(require("../assets/MusicEditor/flat.png"));

var _flat_disabled = _interopRequireDefault(require("../assets/MusicEditor/flat_disabled.png"));

var _natural = _interopRequireDefault(require("../assets/MusicEditor/natural.png"));

var _natural_disabled = _interopRequireDefault(require("../assets/MusicEditor/natural_disabled.png"));

var _pause = _interopRequireDefault(require("../assets/MusicEditor/pause.png"));

var _play = _interopRequireDefault(require("../assets/MusicEditor/play.png"));

var _play_disabled = _interopRequireDefault(require("../assets/MusicEditor/play_disabled.png"));

var _sharp = _interopRequireDefault(require("../assets/MusicEditor/sharp.png"));

var _sharp_disabled = _interopRequireDefault(require("../assets/MusicEditor/sharp_disabled.png"));

var _whole = _interopRequireDefault(require("../assets/MusicEditor/whole.png"));

var _S = _interopRequireDefault(require("../assets/MusicEditor/S.png"));

var _A = _interopRequireDefault(require("../assets/MusicEditor/A.png"));

var _T = _interopRequireDefault(require("../assets/MusicEditor/T.png"));

var _B = _interopRequireDefault(require("../assets/MusicEditor/B.png"));

var _durations;

var DEBUG = false;
var icons = {
  dblflat: _dblflat.default,
  dblflat_disabled: _dblflat_disabled.default,
  dblsharp: _dblsharp.default,
  dblsharp_disabled: _dblsharp_disabled.default,
  flat: _flat.default,
  flat_disabled: _flat_disabled.default,
  natural: _natural.default,
  natural_disabled: _natural_disabled.default,
  pause: _pause.default,
  play: _play.default,
  play_disabled: _play_disabled.default,
  sharp: _sharp.default,
  sharp_disabled: _sharp_disabled.default,
  whole: _whole.default,
  S: _S.default,
  A: _A.default,
  T: _T.default,
  B: _B.default
};
exports.icons = icons;
var midiBuffer;

function get_abs_pitch(i) {
  var pitch = {};

  if (i.pitch) {
    pitch = i;
    i = i.pitch;
  }

  var letters = ["C", "D", "E", "F", "G", "A", "B"];
  var suffix = "";

  while (i < 0) {
    suffix += ",";
    i += letters.length;
  }

  while (i >= letters.length) {
    suffix += "'";
    i -= letters.length;
  }

  if (pitch.accidental) {
    return accidentals[pitch.accidental] + letters[i] + suffix;
  }

  return letters[i] + suffix;
}

function get_treble_pitch(i, humanReadable) {
  return get_abs_pitch(i, humanReadable);
}

function get_bass_pitch(i, humanReadable) {
  return get_abs_pitch(i - 12, humanReadable);
}

function get_alto_pitch(i, humanReadable) {
  return get_abs_pitch(i - 6, humanReadable);
}

function get_abs_pitch_number(pitch) {
  var letters = ["C", "D", "E", "F", "G", "A", "B"];
  var num = letters.indexOf(pitch[0]);

  if (num === -1) {
    throw new Error("Invalid note name");
  }

  for (var i = 1; i < pitch.length; ++i) {
    if (pitch[i] === "'") {
      num += 12;
    } else if (pitch[i] === ",") {
      num -= 12;
    } else {
      throw new Error("Invalid note pitch");
    }
  }

  return num;
}

function get_treble_pitch_number(pitch) {
  return get_abs_pitch_number(pitch);
}

function get_bass_pitch_number(pitch) {
  return get_abs_pitch_number(pitch) + 12;
}

function get_alto_pitch_number(pitch) {
  return get_abs_pitch_number(pitch) + 6;
}

function addDurationSuffix(i) {
  if (i === 1) {
    return "whole";
  } else if (i === 2) {
    return "half";
  } else if (i === 4) {
    return "quarter";
  } else if (i >= 10 && i <= 20) {
    return i + "th";
  }

  var ones = i % 10;

  if (ones === 1) {
    return i + "st";
  } else if (ones === 2) {
    return i + "nd";
  } else if (ones === 3) {
    return i + "rd";
  }

  return i + "th";
}

function ordinal(i) {
  if (i >= 11 && i <= 13) {
    return i + "th";
  }

  var ones = i % 10;
  return i + ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][ones];
}

function describeNotation(notation, readAnnotations, parse) {
  if (parse === undefined) {
    parse = _abcjs.default.parseOnly(notation);
  }

  var ret = "";

  var _iterator = (0, _createForOfIteratorHelper2.default)(parse[0].lines),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var line = _step.value;
      var voicenum = 0;

      var _iterator2 = (0, _createForOfIteratorHelper2.default)(line.staff),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var staff = _step2.value;
          var clef = staff.clef.type;
          var key = "no accidentals";

          if (staff.key.accidentals.length > 0) {
            key = "".concat(staff.key.accidentals.length, " accidental").concat(staff.key.accidentals.length === 1 ? '' : 's');
          }

          ret += " ".concat(clef, " clef with ").concat(key).concat(staff.voices.length > 1 ? ',' : ':');

          var _iterator3 = (0, _createForOfIteratorHelper2.default)(staff.voices),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var voice = _step3.value;
              ++voicenum;

              if (staff.voices.length > 1) {
                ret += " ".concat(ordinal(voicenum), " voice: ");
              }

              var _iterator4 = (0, _createForOfIteratorHelper2.default)(voice),
                  _step4;

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var note = _step4.value;

                  if (note.el_type === "note") {
                    var duration = describeNoteDuration(note.duration);

                    if (note.rest) {
                      ret += " ".concat(duration, " rest");
                    } else {
                      var pitches = [];

                      var _iterator5 = (0, _createForOfIteratorHelper2.default)(note.pitches),
                          _step5;

                      try {
                        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                          var pitch = _step5.value;
                          pitches.push(describePitch(pitch));
                        }
                      } catch (err) {
                        _iterator5.e(err);
                      } finally {
                        _iterator5.f();
                      }

                      if (note.pitches.length === 1) {
                        ret += " ".concat(pitches.join(' '), " ").concat(duration, " note");
                      } else {
                        ret += " [".concat(pitches.join(' '), "] ").concat(duration, " chord");
                      }
                    }
                  } else if (note.el_type === "bar") {
                    if (note.type === "bar_thin") {
                      ret += ",";
                    } else if (note.type === "bar_thin_thin") {
                      ret += ".";
                    } else if (note.type === "bar_left_repeat") {
                      ret += ". start repeat:";
                    } else if (note.type === "bar_right_repeat") {
                      ret += ". end repeat.";
                    } else {
                      DEBUG && console.log("describeNotation bar unknown", note.type);
                    }
                  } else {
                    DEBUG && console.log("describeNotation type unknown", note.el_type, note);
                  }

                  if (note.chord && readAnnotations) {
                    var _iterator6 = (0, _createForOfIteratorHelper2.default)(note.chord),
                        _step6;

                    try {
                      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var chord = _step6.value;
                        ret += " annotated \"".concat(chord.name, "\"");
                      }
                    } catch (err) {
                      _iterator6.e(err);
                    } finally {
                      _iterator6.f();
                    }
                  }
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return ret;
}

function describeTreblePitchPos(i) {
  return describePitch({
    pitch: i
  });
}

function describeBassPitchPos(i) {
  return describeTreblePitchPos(i - 12);
}

function describeAltoPitchPos(i) {
  return describeTreblePitchPos(i - 6);
}

function describePitch(pitch) {
  var i = pitch.pitch;
  var letters = ["C", "D", "E", "F", "G", "A", "B"];
  var octave = 4;

  while (i < 0) {
    octave--;
    i += letters.length;
  }

  while (i >= letters.length) {
    octave++;
    i -= letters.length;
  }

  if (pitch.accidental) {
    return "".concat(letters[i], " ").concat(pitch.accidental, " ").concat(octave);
  }

  return letters[i] + octave;
}

function describeNoteDuration(duration) {
  var frac = new _fractional.Fraction(duration);

  if (frac.numerator === 1) {
    return addDurationSuffix(frac.denominator);
  } else if (frac.denominator == 1) {
    return ["", "whole", "double whole", "triple whole", "quadruple whole"][frac.numerator];
  } else if (frac.numerator === 3) {
    return "dotted " + addDurationSuffix(frac.denominator / 2);
  } else if (frac.numerator === 7) {
    return "double dotted" + addDurationSuffix(frac.denominator / 4);
  }

  return frac.numerator + "/" + addDurationSuffix(frac.denominator);
}

var durations = (_durations = {
  1: "𝅝"
}, (0, _defineProperty2.default)(_durations, 1 / 2, "𝅗𝅥"), (0, _defineProperty2.default)(_durations, 1 / 4, "𝅘𝅥"), (0, _defineProperty2.default)(_durations, 1 / 8, "𝅘𝅥𝅮"), (0, _defineProperty2.default)(_durations, 1 / 16, "𝅘𝅥𝅯"), _durations); // const dot = "𝅭"

exports.durations = durations;
var accidentals = {
  sharp: "^",
  flat: "_",
  natural: "=",
  dblsharp: "^^",
  dblflat: "__"
};
exports.accidentals = accidentals;
var accidentals_code = {
  "^": "sharp",
  "_": "flat",
  "=": "natural",
  "^^": "dblsharp",
  "__": "dblflat"
};
exports.accidentals_code = accidentals_code;
var accidentals_pretty = {
  sharp: "♯",
  flat: "♭",
  natural: "♮",
  dblsharp: "𝄪",
  dblflat: "𝄫"
};
exports.accidentals_pretty = accidentals_pretty;
var accidentals_to_metadata = {
  sharp: "music_button_sharp",
  flat: "music_button_flat",
  natural: "music_button_natural",
  dblsharp: "music_button_double_sharp",
  dblflat: "music_button_double_flat"
};
exports.accidentals_to_metadata = accidentals_to_metadata;
var accidentals_to_props = {
  sharp: "musicButtonSharp",
  flat: "musicButtonFlat",
  natural: "musicButtonNatural",
  dblsharp: "musicButtonDoubleSharp",
  dblflat: "musicButtonDoubleFlat"
};
exports.accidentals_to_props = accidentals_to_props;
var annotation_position_to_character = {
  below: "_",
  above: "^",
  left: "<",
  right: ">",
  default: ""
};
exports.annotation_position_to_character = annotation_position_to_character;

var MusicEditor = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MusicEditor, _React$Component);

  var _super = (0, _createSuper2.default)(MusicEditor);

  function MusicEditor(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MusicEditor);
    _this = _super.call(this, props);
    var annotations = props.annotationAltText !== undefined ? props.annotationAltText.split(",") : undefined;
    DEBUG && console.log("MusicEditor constructor");
    _this.state = {
      width: 300,
      accidental: "",
      duration: undefined,
      cursorNote: 0,
      cursorPitch: 0,
      editorActive: false,
      showHint: false,
      clicked: false,
      annotations: annotations
    };
    _this.updateWidth = _this.updateWidth.bind((0, _assertThisInitialized2.default)(_this));
    _this.callback = _this.callback.bind((0, _assertThisInitialized2.default)(_this));
    _this.playButton = _this.playButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderNotation = _this.renderNotation.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInput = _this.handleInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.findNoteByIndex = _this.findNoteByIndex.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateCurrentHotspot = _this.updateCurrentHotspot.bind((0, _assertThisInitialized2.default)(_this));
    _this.describeVerticalPitchClass = _this.describeVerticalPitchClass.bind((0, _assertThisInitialized2.default)(_this));
    _this.changePlayState = _this.changePlayState.bind((0, _assertThisInitialized2.default)(_this));
    _this.generateSummary = _this.generateSummary.bind((0, _assertThisInitialized2.default)(_this));
    _this.ref = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(MusicEditor, [{
    key: "serializeNote",
    value: function serializeNote(note, extra, clef) {
      var ret = "";

      if (note.chord) {
        var _iterator7 = (0, _createForOfIteratorHelper2.default)(note.chord),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _annotation_position_;

            var chord = _step7.value;
            ret += "\"".concat((_annotation_position_ = annotation_position_to_character[chord.position]) !== null && _annotation_position_ !== void 0 ? _annotation_position_ : "@").concat(chord.name, "\"");
            DEBUG && console.log("serializeNote chord", chord);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }

      if (note.gracenotes) {
        ret += "{";

        var _iterator8 = (0, _createForOfIteratorHelper2.default)(note.gracenotes),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var grace = _step8.value;

            if (clef === "treble") {
              ret += get_treble_pitch(grace.pitch);
            } else if (clef === "bass") {
              ret += get_bass_pitch(grace.pitch);
            } else if (clef === "alto") {
              ret += get_alto_pitch(grace.pitch);
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        ret += "}";
      }

      if (note.decoration) {
        var _iterator9 = (0, _createForOfIteratorHelper2.default)(note.decoration),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var dec = _step9.value;

            if (dec === "irishroll") {
              ret += "~";
            } else {
              console.log("unknown decoration: ", dec);
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }

      if (note.rest) {
        ret += "z";
      } else if (note.pitches) {
        if (note.pitches.length > 1) ret += "[";

        var _iterator10 = (0, _createForOfIteratorHelper2.default)(note.pitches),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var pitch = _step10.value;

            if (clef === "bass") {
              ret += (accidentals[pitch.accidental] || "") + get_bass_pitch(pitch.verticalPos);
            } else if (clef === "treble") {
              ret += (accidentals[pitch.accidental] || "") + get_treble_pitch(pitch.pitch);
            } else if (clef === "alto") {
              ret += (accidentals[pitch.accidental] || "") + get_alto_pitch(pitch.verticalPos);
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        if (note.pitches.length > 1) ret += "]";
      }

      var default_length = this.lastParse && this.lastParse[0].multilineVars && this.lastParse[0].multilineVars.default_length || 0.25;

      if (note.duration !== default_length) {
        var ratio = new _fractional.Fraction(note.duration / default_length);
        var frac = ratio.numerator;
        if (ratio.denominator !== 1) frac += "/" + ratio.denominator;
        ret += frac;
      }

      DEBUG && console.log("serializeNote extra", extra);
      if (extra === undefined) extra = note.endChar - note.startChar - ret.length;
      DEBUG && console.log("serializeNote extra now", extra);

      if (extra > 0) {
        if (note.pitches && (note.pitches[0].startSlur || note.pitches[0].endSlur)) extra--;else ret += " ".repeat(extra);
      }

      DEBUG && console.log("serializeNote ret", ret);
      return ret;
    }
  }, {
    key: "callback",
    value: function callback(pitch, e, manual) {
      if (this.props.completed) {
        return;
      }

      var offset = this.props.precursor ? this.props.precursor.length : 0;
      var oldNote = this.props.notation.substring(e.abcelem.startChar - offset, e.abcelem.endChar - offset);

      var _iterator11 = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var line = _step11.value;

          var _iterator12 = (0, _createForOfIteratorHelper2.default)(line.staff),
              _step12;

          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var staff = _step12.value;

              var _iterator13 = (0, _createForOfIteratorHelper2.default)(staff.voices),
                  _step13;

              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  var voice = _step13.value;
                  var i = 0;
                  var clef = staff.clef.type;

                  var _iterator14 = (0, _createForOfIteratorHelper2.default)(voice),
                      _step14;

                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      var note = _step14.value;

                      // console.log(note)
                      if (note.startChar === e.abcelem.startChar) {
                        // console.log("^^matched note!")
                        var new_pitch = {
                          pitch: pitch,
                          verticalPos: pitch,
                          accidental: accidentals_code[this.state.accidental]
                        }; // check how long the note is before doing anything

                        DEBUG && console.log("callback doing old extra");
                        var oldExtra = note.endChar - note.startChar - this.serializeNote(note, 0, clef).length;
                        DEBUG && console.log("callback oldExtra", oldExtra);
                        note.duration = this.state.duration; // TODO: enforce all notes in a measure adding up to 1

                        if (note.rest) {
                          note.rest = undefined;
                          note.pitches = [new_pitch];
                        } else if (note.pitches) {
                          if (this.props.monophonic) {
                            if (note.pitches[0].verticalPos !== new_pitch.pitch || note.pitches[0].accidental !== new_pitch.accidental) {
                              note.pitches = [new_pitch];
                            } else {
                              note.rest = {
                                type: 'rest'
                              };
                              delete note.pitches;
                            }
                          } else {
                            var _i = note.pitches.findIndex(function (e) {
                              return e.verticalPos === pitch;
                            });

                            if (_i !== -1) {
                              if (note.pitches[_i].accidental === new_pitch.accidental) {
                                note.pitches.splice(_i, 1);
                              } else {
                                note.pitches.splice(_i, 1, new_pitch);
                              }
                            } else {
                              note.pitches.push(new_pitch);
                              note.pitches.sort(function (a, b) {
                                return a.pitch - b.pitch;
                              });
                            }

                            if (note.pitches.length === 0) {
                              note.rest = {
                                type: 'rest'
                              };
                              delete note.pitches;
                            }
                          }
                        }

                        DEBUG && console.log("callback doing actual");
                        oldNote = this.serializeNote(note, oldExtra, clef);
                        this.setState({
                          cursorNote: i,
                          cursorPitch: pitch
                        });
                      }

                      if (note.el_type === "note") ++i;
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      var newNotation = this.props.notation.substring(0, e.abcelem.startChar - offset) + oldNote + this.props.notation.substring(e.abcelem.endChar - offset);
      this.props.onChange(newNotation);

      if (!this.state.clicked) {
        this.setState({
          showHint: false,
          clicked: true
        });
      }
    }
  }, {
    key: "updateWidth",
    value: function updateWidth() {
      if (this.state.width !== this.container.offsetWidth) this.setState({
        width: this.container.offsetWidth
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener("resize", this.updateWidth);
      this.updateWidth();
      DEBUG && console.log("MusicEditor componentDidMount rendering");
      this.renderNotation();
      this.setState({
        duration: this.lastParse && this.lastParse[0].multilineVars && this.lastParse[0].multilineVars.default_length || 0.25
      }); // this.unitTest()

      setTimeout(function () {
        if (!_this2.state.clicked && !_this2.props.completed) _this2.setState({
          showHint: true
        });
      }, 14000);
      var note = this.findNoteByIndex(0);

      if (note && note.hotspots) {
        var hotspot = note.hotspots["0"];

        if (hotspot) {
          hotspot.tabIndex = "0";
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateWidth);
    }
  }, {
    key: "describeVerticalPitchClass",
    value: function describeVerticalPitchClass(verticalPos) {
      var _this$props$rangeLowe, _this$props$rangeUppe;

      if (verticalPos < ((_this$props$rangeLowe = this.props.rangeLower) !== null && _this$props$rangeLowe !== void 0 ? _this$props$rangeLowe : -3) || verticalPos > ((_this$props$rangeUppe = this.props.rangeUpper) !== null && _this$props$rangeUppe !== void 0 ? _this$props$rangeUppe : 15)) return '?';
      var clef = this.lastParse[0].lines[0].staff[0].clef.type;
      if (clef === "treble") return describeTreblePitchPos(verticalPos);else if (clef === "alto") return describeAltoPitchPos(verticalPos);else if (clef === "bass") return describeBassPitchPos(verticalPos);
    }
  }, {
    key: "getKeyAccidental",
    value: function getKeyAccidental(verticalPos) {
      var _iterator15 = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines[0].staff[0].key.accidentals),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var accidental = _step15.value;

          if (accidental.verticalPos === verticalPos) {
            return accidental.acc;
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }
  }, {
    key: "renderNotation",
    value: function renderNotation() {
      var _this3 = this;

      var render_config = {
        add_hotspots: this.props.addHotspots,
        add_classes: this.props.addClasses,
        hotspot_width_scale: this.props.hotspotWidthScale || 1,
        scale: this.props.zoom || 1,
        staffwidth: this.state.width || "95%",
        click_line_callback: this.callback,
        paddingtop: 0,
        paddingbottom: -80,
        paddingleft: 0,
        paddingright: 0,
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper
      };

      if (this.props.musicStaffWrap) {
        render_config.wrap = {
          minspacing: 1.8,
          maxspacing: 2.7,
          preferredmeasuresperline: 4
        };
      }

      this.lastParse = _abcjs.default.renderAbc(this.container, (this.props.precursor || "") + this.props.notation + "||", render_config); //console.log("lastParse", this.lastParse)

      if (this.props.onRender) this.props.onRender(this.lastParse); // Make sure numNotes is updated

      this.findNoteByIndex(0); // Mark up the hotspots for aria

      var _loop = function _loop(i) {
        var note = _this3.findNoteByIndex(i);

        if (note && note.hotspots) {
          var _loop2 = function _loop2(_j) {
            var hotspot = note.hotspots["" + _j];

            if (hotspot) {
              //increment so that they start at 1
              hotspot.setAttribute("id", "music-editor-cell-".concat(_j, "-").concat(i + 1)); //hotspot.setAttribute("aria-colindex", i + 1)
              //hotspot.setAttribute("aria-rowindex", j)

              var label = "Your cursor is on note " + (i + 1) + " pitch " + _this3.describeVerticalPitchClass(_j);

              if (note.rest) {
                label += " no current note ";
              } else {
                var _iterator16 = (0, _createForOfIteratorHelper2.default)(note.pitches),
                    _step16;

                try {
                  for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                    var _pitch = _step16.value;
                    label += " current note is " + describePitch(_pitch) + " ";
                  }
                } catch (err) {
                  _iterator16.e(err);
                } finally {
                  _iterator16.f();
                }
              }

              if (_this3.state.annotations && _this3.state.annotations[i] !== undefined) {
                label += "annotation " + _this3.state.annotations[i];
              } //label needs to dif between current hotspot and currently selected


              hotspot.setAttribute("aria-label", label);
              hotspot.addEventListener('mouseenter', function () {
                _this3.setState({
                  cursorNote: i,
                  cursorPitch: _j,
                  editorActive: true
                });
              });
            }
          };

          for (var _j = (_this3$props$rangeUpp = _this3.props.rangeUpper) !== null && _this3$props$rangeUpp !== void 0 ? _this3$props$rangeUpp : 15; _j >= ((_this3$props$rangeLow = _this3.props.rangeLower) !== null && _this3$props$rangeLow !== void 0 ? _this3$props$rangeLow : -3); _j--) {
            var _this3$props$rangeUpp, _this3$props$rangeLow;

            _loop2(_j);
          }
        }
      };

      for (var i = 0; i < this.numNotes; i++) {
        _loop(i);
      }

      var svg = this.lastParse[0].engraver.renderer.paper.svg;

      for (var j = (_this$props$rangeUppe2 = this.props.rangeUpper) !== null && _this$props$rangeUppe2 !== void 0 ? _this$props$rangeUppe2 : 15; j >= ((_this$props$rangeLowe2 = this.props.rangeLower) !== null && _this$props$rangeLowe2 !== void 0 ? _this$props$rangeLowe2 : -3); j--) {
        var _this$props$rangeUppe2, _this$props$rangeLowe2;

        var row = document.createElementNS("http://www.w3.org/2000/svg", "g");
        var pitch = this.describeVerticalPitchClass(j);
        var acc = this.getKeyAccidental(j);

        if (acc) {
          pitch += " ".concat(acc);
        }

        if (j >= 2 && j <= 10) {
          pitch += " staff";
        } else {
          pitch += " ledger";
        }

        if (j & 1) {
          // is the number odd?
          pitch += " space";
        } else {
          pitch += " line";
        }

        row.setAttribute("role", "row");
        row.setAttribute("aria-label", pitch);
        svg.appendChild(row);
        svg.setAttribute("aria-label", "sheet music");

        for (var _i2 = 0; _i2 < this.numNotes; _i2++) {
          var note = this.findNoteByIndex(_i2);

          if (note && note.hotspots) {
            var hotspot = note.hotspots["" + j];

            if (hotspot) {
              row.appendChild(hotspot);
            }
          }
        }
      }
    }
  }, {
    key: "findNoteByIndex",
    value: function findNoteByIndex(index) {
      var ret;
      var i = 0;

      var _iterator17 = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var line = _step17.value;

          var _iterator18 = (0, _createForOfIteratorHelper2.default)(line.staff),
              _step18;

          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var staff = _step18.value;

              var _iterator19 = (0, _createForOfIteratorHelper2.default)(staff.voices),
                  _step19;

              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  var voice = _step19.value;

                  var _iterator20 = (0, _createForOfIteratorHelper2.default)(voice),
                      _step20;

                  try {
                    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                      var note = _step20.value;

                      if (note.el_type === "note") {
                        if (i === index) {
                          ret = note;
                        }

                        ++i;
                      }

                      this.numNotes = i;
                    }
                  } catch (err) {
                    _iterator20.e(err);
                  } finally {
                    _iterator20.f();
                  }
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      return ret;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var changed = [];

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (this.props[key] !== prevprops[key]) {
          changed.push("props.".concat(key));
        }
      }

      for (var _i4 = 0, _Object$keys2 = Object.keys(this.state); _i4 < _Object$keys2.length; _i4++) {
        var _key = _Object$keys2[_i4];

        if (this.state[_key] !== prevstate[_key]) {
          changed.push("state.".concat(_key));
        }
      }

      if (changed.length > 0) {
        DEBUG && console.log("MusicEditor rerender from", changed.join(", "));
        this.renderNotation();
      }

      if (this.props.completed) {
        var notes = this.ref.current.getElementsByClassName('abcjs-note');
        var rests = this.ref.current.getElementsByClassName('abcjs-rest');
        var chord_lines = this.ref.current.getElementsByClassName('staff-line');
        var chord_spaces = this.ref.current.getElementsByClassName('staff-space');

        for (var k = 0; k < notes.length; k++) {
          notes[k].nextElementSibling.style.pointerEvents = "none";
        }

        for (var _k = 0; _k < rests.length; _k++) {
          rests[_k].nextElementSibling.style.pointerEvents = "none";
        }

        for (var _k2 = 0; _k2 < chord_lines.length; _k2++) {
          chord_lines[_k2].style.pointerEvents = "none";
        }

        for (var _k3 = 0; _k3 < chord_spaces.length; _k3++) {
          chord_spaces[_k3].style.pointerEvents = "none";
        }
      }

      if (prevstate.editorActive !== this.state.editorActive || prevstate.width !== this.state.width || prevprops.notation !== this.props.notation || prevstate.cursorNote !== this.state.note || prevstate.cursorPitch !== this.state.pitch) {
        this.updatePreviousHotspot(prevstate);
        var note = this.findNoteByIndex(this.state.cursorNote);
        this.currentNote = note;
        this.updateCurrentHotspot(note, prevstate);
      }
    }
  }, {
    key: "updatePreviousHotspot",
    value: function updatePreviousHotspot(prevstate) {
      if (prevstate.cursorNote !== this.state.cursorNote || prevstate.cursorPitch !== this.state.cursorPitch) {
        var note = this.findNoteByIndex(prevstate.cursorNote);

        if (note && note.hotspots) {
          var hotspot = note.hotspots["" + prevstate.cursorPitch];

          if (hotspot) {
            hotspot.style.removeProperty("fill-opacity");
            hotspot.tabIndex = "-1";

            if (hotspot.correctAccidental && this.state.accidental === hotspot.correctAccidental) {
              this.setState({
                accidental: ""
              });
            }
          }
        }
      }
    }
  }, {
    key: "updateCurrentHotspot",
    value: function updateCurrentHotspot(note, prevstate) {
      if (note.hotspots) {
        var hotspot = note.hotspots["" + this.state.cursorPitch];

        if (hotspot) {
          if (hotspot.classList.value.includes('green')) {
            hotspot.style.cssText = "fill-opacity: 0.6 !important";
            hotspot.style["fill"] = "#52AF52";
            hotspot.style["outline"] = 'none';

            if (hotspot.correctAccidental && this.state.accidental !== hotspot.correctAccidental) {
              this.setState({
                accidental: hotspot.correctAccidental
              });
            }
          } else if (this.state.editorActive) {
            hotspot.style["fill-opacity"] = 0.2;
            hotspot.style["outline"] = 'none';
          } else {
            hotspot.style["fill-opacity"] = 0;
          }

          hotspot.tabIndex = "0";

          if (this.state.editorActive) {
            hotspot.focus();
          }
        }
      }
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      var _this$props$rangeUppe3, _this$props$rangeLowe3, _this$props$rangeUppe4, _this$props$rangeLowe4;

      if (e.keyCode === 37 && this.state.cursorNote > 0) {
        // left
        this.setState({
          cursorNote: this.state.cursorNote - 1
        });
        e.preventDefault();
      }

      if (e.keyCode === 39 && this.state.cursorNote < this.numNotes - 1) {
        // right
        this.setState({
          cursorNote: this.state.cursorNote + 1
        });
        e.preventDefault();
      }

      if (e.keyCode === 38 && this.state.cursorPitch < ((_this$props$rangeUppe3 = this.props.rangeUpper) !== null && _this$props$rangeUppe3 !== void 0 ? _this$props$rangeUppe3 : 15)) {
        // up
        this.setState({
          cursorPitch: this.state.cursorPitch + 1
        });
        e.preventDefault();
      }

      if (e.keyCode === 40 && this.state.cursorPitch > ((_this$props$rangeLowe3 = this.props.rangeLower) !== null && _this$props$rangeLowe3 !== void 0 ? _this$props$rangeLowe3 : -3)) {
        // down
        this.setState({
          cursorPitch: this.state.cursorPitch - 1
        });
        e.preventDefault();
      }

      if (e.keyCode === 13 || e.keyCode === 32) {
        if (this.currentNote) this.callback(this.state.cursorPitch, this.currentNote.abselem, true);
      }

      if ((e.keyCode === 33 || e.keyCode === 36 && e.ctrlKey) && this.state.cursorPitch < ((_this$props$rangeUppe4 = this.props.rangeUpper) !== null && _this$props$rangeUppe4 !== void 0 ? _this$props$rangeUppe4 : 15)) {
        var _this$props$rangeUppe5;

        // PgUp or ctrl home
        this.setState({
          cursorPitch: (_this$props$rangeUppe5 = this.props.rangeUpper) !== null && _this$props$rangeUppe5 !== void 0 ? _this$props$rangeUppe5 : 15
        });
        e.preventDefault();
      }

      if ((e.keyCode === 34 || e.keyCode === 35 && e.ctrlKey) && this.state.cursorPitch > ((_this$props$rangeLowe4 = this.props.rangeLower) !== null && _this$props$rangeLowe4 !== void 0 ? _this$props$rangeLowe4 : -3)) {
        var _this$props$rangeLowe5;

        // PgDn or ctrl end
        this.setState({
          cursorPitch: (_this$props$rangeLowe5 = this.props.rangeLower) !== null && _this$props$rangeLowe5 !== void 0 ? _this$props$rangeLowe5 : -3
        });
        e.preventDefault();
      }

      if (e.keyCode === 35 && this.state.cursorNote < this.numNotes - 1) {
        // end
        this.setState({
          cursorNote: this.numNotes - 1
        });
        e.preventDefault();
      }

      if (e.keyCode === 36 && this.state.cursorNote > 0) {
        // home
        this.setState({
          cursorNote: 0
        });
        e.preventDefault();
      }

      if (e.defaultPrevented) {
        this.setState({
          editorActive: true
        });
      }
    }
  }, {
    key: "generatePlaybackNotation",
    value: function generatePlaybackNotation(notation) {
      if (!this.props.chordMode) return notation;
      var playback = "";
      var playbackChord = "[";

      var parse = _abcjs.default.parseOnly(notation);

      var clef = parse[0].lines[0].staff[0].clef.type;
      var notes = parse[0].lines[0].staff[0].voices[0];
      notes[0].pitches.sort(function (a, b) {
        return a.pitch < b.pitch ? -1 : 1;
      });

      var _iterator21 = (0, _createForOfIteratorHelper2.default)(notes),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var note = _step21.value;

          if (note.pitches) {
            var _iterator22 = (0, _createForOfIteratorHelper2.default)(note.pitches),
                _step22;

            try {
              for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                var pitch = _step22.value;
                var new_note = {
                  "duration": note.duration,
                  "pitches": [pitch],
                  "el_type": "note"
                };
                playback += this.serializeNote(new_note, 0, clef) + "/";
                playbackChord += this.serializeNote(new_note, 0, clef);
              }
            } catch (err) {
              _iterator22.e(err);
            } finally {
              _iterator22.f();
            }
          }

          playbackChord += "]";
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }

      return (this.props.precursor || "") + playback + playbackChord;
    }
  }, {
    key: "changePlayState",
    value: function changePlayState(s) {
      this.setState({
        playing: s
      });
    }
  }, {
    key: "playButton",
    value: function playButton() {
      var _this4 = this;

      if (this.state.playing) {
        //pause button
        this.midiBuffer.pause();
        this.changePlayState(false);
      } else {
        //play button
        this.changePlayState(true);

        if (this.midiBuffer && this.midiBuffer.pausedTimeSec) {
          this.midiBuffer.resume();
        } else {
          var playback = this.generatePlaybackNotation((this.props.precursor || "") + this.props.notation);

          var parse = _abcjs.default.parseOnly(playback)[0];

          if (_abcjs.default.synth.supportsAudio()) {
            // stopAudioButton.setAttribute("style", "");
            // An audio context is needed - this can be passed in for two reasons:
            // 1) So that you can share this audio context with other elements on your page.
            // 2) So that you can create it during a user interaction so that the browser doesn't block the sound.
            // Setting this is optional - if you don't set an audioContext, then abcjs will create one.
            window.AudioContext = window.AudioContext || window.webkitAudioContext || navigator.mozAudioContext || navigator.msAudioContext;
            var audioContext = new window.AudioContext(); // This does a bare minimum so this object could be created in advance, or whenever convenient.

            midiBuffer = new _abcjs.default.synth.CreateSynth(); // midiBuffer.init preloads and caches all the notes needed. There may be significant network traffic here.

            this.midiBuffer = midiBuffer;
            return midiBuffer.init({
              visualObj: parse,
              audioContext: audioContext,
              millisecondsPerMeasure: this.props.millisecondsPerMeasure || 2000
            }).then(function () {
              // midiBuffer.prime actually builds the output buffer.
              midiBuffer.prime();

              midiBuffer.onEnded = function () {
                _this4.changePlayState(false);
              };

              _this4.midiBuffer = midiBuffer;
              return midiBuffer;
            }).then(function () {
              // At this point, everything slow has happened. midiBuffer.start will return very quickly and will start playing very quickly without lag.
              midiBuffer.start(); // console.log(midiBuffer.duration)
              // setTimeout(()=>{this.changePlayState(false)}, midiBuffer.duration * 1000)

              return Promise.resolve();
            }).catch(function (error) {
              if (error.status === "NotSupported") {
                console.warn("not supported!"); // stopAudioButton.setAttribute("style", "display:none;");

                var audioError = this.ref.current.querySelector(".audio-error");
                audioError.setAttribute("style", "");
              } else console.warn("synth error", error);
            });
          } else {
            var audioError = this.ref.current.querySelector(".audio-error");
            audioError.setAttribute("style", "");
            console.warn("failed!");
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this,
          _this$props$rangeUppe6,
          _this$props$rangeLowe6;

      DEBUG && console.log("MusicEditor render");
      var renderTopBar = true;

      if (Object.keys(accidentals).map(function (a) {
        return _this5.props[accidentals_to_props[a]];
      }).filter(function (a) {
        return a;
      }).length === 0) {
        renderTopBar = false;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ref,
        className: "music-editor"
      }, this.props.accidentals && renderTopBar && !this.props.completed && /*#__PURE__*/_react.default.createElement("div", {
        className: "radio-toolbar top"
      }, this.renderPlayButton(), this.renderAccidentalButtons()), /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(e) {
          _this5.container = e;
        },
        "aria-label": "Music Editor",
        "aria-describedby": "desc",
        "aria-live": "off",
        role: "grid",
        "aria-colcount": this.numNotes,
        "aria-rowcount": ((_this$props$rangeUppe6 = this.props.rangeUpper) !== null && _this$props$rangeUppe6 !== void 0 ? _this$props$rangeUppe6 : 15) - ((_this$props$rangeLowe6 = this.props.rangeLower) !== null && _this$props$rangeLowe6 !== void 0 ? _this$props$rangeLowe6 : -3) + 1,
        onKeyDown: this.handleInput,
        onFocus: function onFocus() {
          _this5.setState({
            editorActive: true
          });
        },
        onBlur: function onBlur() {
          _this5.setState({
            editorActive: false
          });
        },
        onMouseLeave: function onMouseLeave() {
          _this5.setState({
            editorActive: false
          });
        },
        style: {
          width: this.props.musicStaffWidth,
          minHeight: this.props.minHeight
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        id: "desc",
        style: {
          width: "1px",
          height: "1px",
          overflow: "hidden"
        }
      }, " ", this.generateSummary()), !this.props.hideHint && this.state.showHint && !this.props.completed && /*#__PURE__*/_react.default.createElement("span", {
        className: "hint"
      }, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("i", null, "Click on the staff to add notes."))));
    }
  }, {
    key: "renderAccidentalButtons",
    value: function renderAccidentalButtons() {
      var _this6 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "radio-button-group",
        style: {
          display: "inline-block",
          width: "75%",
          textAlign: "right"
        },
        role: "radiogroup",
        "aria-label": "Apply an accidental"
      }, /*#__PURE__*/_react.default.createElement("div", null, this.props.musicButtonNote && /*#__PURE__*/_react.default.createElement("div", {
        className: "icon-image-container"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        name: "accidental",
        value: "none",
        id: "none",
        "aria-label": "no accidental",
        onChange: function onChange() {
          _this6.setState({
            accidental: ""
          });
        },
        checked: this.state.accidental === ""
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "none"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "icon-image",
        src: _whole.default,
        alt: ""
      }))), Object.keys(accidentals).map(function (value, code) {
        return _this6.props[accidentals_to_props[value]] && /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-image-container",
          key: value
        }, /*#__PURE__*/_react.default.createElement("input", {
          className: "accidental",
          type: "radio",
          name: "accidental",
          id: value,
          value: value,
          "aria-label": value.replace('dbl', 'double '),
          onChange: function onChange() {
            _this6.setState({
              accidental: accidentals[value]
            });
          },
          checked: _this6.state.accidental === accidentals[value],
          disabled: _this6.props.answer && !_this6.props.answer.join('').includes(accidentals[value])
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: value,
          key: value
        }, _this6.props.answer && !_this6.props.answer.join('').includes(accidentals[value]) ? /*#__PURE__*/_react.default.createElement("img", {
          className: "icon-image",
          src: icons[value + "_disabled"],
          alt: ""
        }) : /*#__PURE__*/_react.default.createElement("img", {
          className: "icon-image",
          src: icons[value],
          alt: ""
        })));
      })));
    }
  }, {
    key: "renderPlayButton",
    value: function renderPlayButton() {
      var _this7 = this;

      if (this.props.notation.trim() === "z") {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-image-container",
          style: {
            width: "25%",
            textAlign: "left",
            float: "left"
          }
        }, this.props.musicButtonAudio && /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: "sb-action-button",
          variant: "dark",
          ref: function ref(e) {
            _this7.play = e;
          },
          "aria-label": "Play",
          disabled: this.props.notation.trim() === "z",
          onClick: this.playButton,
          style: {
            display: "inline-block",
            height: "43px",
            width: "42px",
            padding: "0px"
          }
        }, /*#__PURE__*/_react.default.createElement("img", {
          className: "icon-image",
          src: _play_disabled.default,
          alt: "play"
        })));
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-image-container",
          style: {
            width: "25%",
            textAlign: "left",
            float: "left"
          }
        }, this.props.musicButtonAudio && /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: "sb-action-button",
          variant: "dark",
          ref: function ref(e) {
            _this7.play = e;
          },
          "aria-label": "Play",
          disabled: this.props.notation.trim() === "z",
          onClick: this.playButton,
          style: {
            display: "inline-block",
            height: "43px",
            width: "42px",
            padding: "0px"
          }
        }, this.state.playing ? /*#__PURE__*/_react.default.createElement("img", {
          className: "icon-image",
          src: _pause.default,
          alt: "pause"
        }) : /*#__PURE__*/_react.default.createElement("img", {
          className: "icon-image",
          src: _play.default,
          alt: "play"
        })));
      }
    }
  }, {
    key: "generateSummary",
    value: function generateSummary() {
      var summary = "";

      if (this.lastParse) {
        summary = "current notation: " + describeNotation((this.props.precursor || "") + this.props.notation + "||", this.props.readAnnotations, this.lastParse);
      }

      return summary;
    }
  }]);
  return MusicEditor;
}(_react.default.Component);

exports.default = MusicEditor;
MusicEditor.contextType = _CompletedContext.CompletedContext;